"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCertificateCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("g", {
    fill: "inherit",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M17.829 16.26V7.784a.233.233 0 00-.073-.171.233.233 0 00-.17-.072H6.414a.233.233 0 00-.17.072.233.233 0 00-.073.17v8.479c0 .065.024.122.073.17a.233.233 0 00.17.072h11.172a.233.233 0 00.17-.072.233.233 0 00.073-.17zm.971-8.566v8.567c0 .333-.119.62-.357.857a1.17 1.17 0 01-.857.357H6.414a1.17 1.17 0 01-.857-.357 1.17 1.17 0 01-.357-.857V7.694c0-.334.119-.62.357-.857a1.17 1.17 0 01.857-.357h11.172c.334 0 .62.119.857.357.238.237.357.523.357.857z"
  }), React.createElement("path", {
    d: "M14.171 15.575c-.117.058-.161.173-.127.276.03.091.103.124.223.065.386-.128.478-.31.358-.525-.128.048-.28.108-.454.184zm.454-.184a.81.81 0 00-.164-.196c-.167-.146-.383-.23-.477-.183-.26.13-.324.397-.219.584l-.21.118c-.168-.301-.067-.722.321-.917.226-.112.603.048.837.309a1.003 1.003 0 01.141.207c.162.334.002.66-.495.824-.24.12-.468.016-.543-.21a.468.468 0 01.254-.57c.146-.063.276-.117.391-.162a4.27 4.27 0 01.252-.09c.241-.076.39-.086.47-.029.113.08.152.184.174.363l.005.04c.018.147.031.178.073.188.163.038.303.006.632-.122.181-.071.263-.1.368-.124l.054.233a2.34 2.34 0 00-.335.114c-.375.146-.547.186-.774.132-.18-.042-.227-.15-.256-.392l-.005-.038c-.014-.117-.034-.17-.074-.198-.011-.008-.078.006-.19.04-.064.02-.14.046-.23.08z",
    fillRule: "nonzero"
  }), React.createElement("path", {
    d: "M8.8 10.88h6.491v1H8.8zM9.2 12.48h5.564v1H9.2zM7.2 14.88h3.4v1H7.2zM11.6 8.08v1.442l.618-.618.618.618V8.08z"
  }), React.createElement("path", {
    d: "M12 0C5.372 0 0 5.373 0 12c0 6.628 5.372 12 12 12 6.627 0 12-5.372 12-12 0-6.626-5.374-12-12-12zm0 1.532c5.78 0 10.468 4.688 10.468 10.468 0 5.782-4.687 10.468-10.468 10.468-5.782 0-10.468-4.686-10.468-10.468C1.532 6.22 6.218 1.532 12 1.532z",
    fillRule: "nonzero"
  })));
}

var _default = SvgCertificateCircle;
exports.default = _default;